import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { View } from 'foundations-components/components/View';
import UIFlex from 'UIComponents/layout/UIFlex';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import UIList from 'UIComponents/list/UIList';
import { RequestState } from 'platform-dashboard-ui/filter/requests/request-state';
// @ts-expect-error migrate upstream dependency
import { getDashboardReports } from 'dashboard-lib/public/dashboard/dashboard-logic';
// @ts-expect-error migrate upstream dependency
import { getId as getDashboardId } from 'dashboard-lib/public/dashboard/dashboard-schema';
// @ts-expect-error migrate upstream dependency
import { useUserRoleForDashboard } from 'reporting-action-components/utils/trackingUtils';
import { getAppliedFilterOperator, setDashboardId
// @ts-expect-error migrate upstream dependency
} from '../../../../ducks/quick-filters/quickFilters';
import PinnedPropertyFilter from './PinnedPropertyFilter';
import { GenerateQuickFilterGroupsPopover } from './GenerateQuickFilterGroupsPopover';
import useQuickFilterFetchDataSources from './hooks/useQuickFilterFetchDataSources';
import useCanEditQuickFilter from './hooks/useCanEditQuickFilter';
import GroupedPinnedPropertyFilter from './groupedQuickFilters/GroupedPinnedPropertyFilter';
import { selectQuickFilterGroupWithHydratedProperties, selectQuickFilterOperators, selectQuickFilterToProperty } from '../../../../ducks/quick-filters';
import { selectHasDashboardFiltersInitialized } from '../../../../ducks/applied-dashboard-filters';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const PinnedPropertiesContainer = ({
  dashboard
}) => {
  const userRole = useUserRoleForDashboard(dashboard);
  const dispatch = useDispatch();
  const dashboardId = getDashboardId(dashboard);
  const hasInitializedDashboardFilters = useSelector(selectHasDashboardFiltersInitialized(dashboardId));
  const userHasQuickFilterEditPermission = useCanEditQuickFilter({
    dashboard
  });
  const appliedQuickFilterOperators = useSelector(selectQuickFilterOperators(dashboardId));
  const fetchDataStatus = useQuickFilterFetchDataSources();
  const properties = useSelector(selectQuickFilterToProperty);
  const quickFilterGroups = useSelector(selectQuickFilterGroupWithHydratedProperties);
  const reports = getDashboardReports(dashboard);
  useEffect(() => {
    dispatch(setDashboardId(dashboardId));
  }, [dispatch, dashboardId]);
  if (fetchDataStatus === RequestState.FAILED || reports.length === 0) {
    return null; // TODO: add error message
  }
  if (!hasInitializedDashboardFilters || fetchDataStatus === RequestState.PENDING) {
    return /*#__PURE__*/_jsx(UILoadingSpinner, {
      layout: "centered"
    });
  }
  const getAppliedFilterOperatorFunc = getAppliedFilterOperator(appliedQuickFilterOperators);
  const renderQuickFilterAccessButton = () => {
    return /*#__PURE__*/_jsx(GenerateQuickFilterGroupsPopover, {
      dashboard: dashboard
    });
  };
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsxs(UIFlex, {
      align: "center",
      children: [renderQuickFilterAccessButton(), /*#__PURE__*/_jsx(UIList, {
        inline: true,
        children: quickFilterGroups.map(quickFilterGroup => {
          const {
            name: quickFilterGroupName
          } = quickFilterGroup;
          return /*#__PURE__*/_jsx(GroupedPinnedPropertyFilter, {
            dashboardId: dashboardId,
            quickFilterGroup: quickFilterGroup,
            userHasQuickFilterEditPermission: userHasQuickFilterEditPermission,
            userRole: userRole
          }, quickFilterGroupName);
        })
      }), /*#__PURE__*/_jsx(UIList, {
        inline: true,
        children: properties.map(({
          dataSource,
          property,
          name
        }) => {
          const prevOperator = getAppliedFilterOperatorFunc(dataSource, property, name);
          return /*#__PURE__*/_jsx(PinnedPropertyFilter, {
            dataSource: dataSource,
            property: property,
            dashboardId: dashboardId,
            prevOperator: prevOperator,
            userHasQuickFilterEditPermission: userHasQuickFilterEditPermission,
            userRole: userRole
          }, `${dataSource}-${name}`);
        })
      }), /*#__PURE__*/_jsx(View, {
        blockSize: "24px",
        inlineSize: "2px",
        backgroundColor: "border-core-default",
        marginInline: "700"
      })]
    })
  });
};
export default PinnedPropertiesContainer;